import { Card, CardHeader } from '@m/alchemy-ui';
import styled from 'styled-components';

export const CardHeaderStyled = styled(CardHeader)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CardStyled = styled(Card)`
  width: 100%;
`;

export const ErrorContainer = styled.div`
  margin-top: 20px;
`;

export const ErrorTitle = styled.h3``;
